const { scopeIslandRootEmotionStylisPlugin } = require('./scope-island-root-emotion-stylis-plugin');
const { scaleRpUiRemStylisPlugin } = require('./scale-rp-ui-emotion-rem-stylis-plugin');
const { prefixer } = require('stylis');

/** @returns {import('stylis').Middleware[]} */
function islandEmotionStylisPlugins() {
	return [scopeIslandRootEmotionStylisPlugin, scaleRpUiRemStylisPlugin, prefixer];
}

module.exports = { islandEmotionStylisPlugins };
